import { cloneDeep } from 'lodash';
import { Asset } from '../../../store/Asset';
import { ProvisionalAsset } from '../../../store/ProvisionalAsset';
import { FinancialEditPayload, getIdentityFields } from './EditModal/financialEditHelpers';

const isAssetRecord = (data: object): data is Asset => 'totalMRC' in data;
const isProvisionalAssetRecord = (data: object): data is ProvisionalAsset => 'provisionalType' in data;

export const buildInlineSavePayload = <Entity extends object>(
  data: Entity,
  changes: Record<string, unknown>
): Entity | FinancialEditPayload => {
  if (isAssetRecord(data)) return { ...getIdentityFields('asset', data), ...changes } as FinancialEditPayload;
  if (isProvisionalAssetRecord(data)) {
    return { ...getIdentityFields('provisionalAsset', data), ...changes } as FinancialEditPayload;
  }
  return { ...cloneDeep(data), ...changes };
};
